<template>
  <v-dialog v-model="dialog" max-width="800">
    <ValidationObserver ref="createPriceForm" v-slot="{ invalid, passes }">
      <form
        rel="createPriceForm"
        class="flex flex-wrap justify-between sm:justify-center"
        @submit.prevent="passes(submit)"
      >
        <v-card>
          <v-card-title class="pa-7"> Nový ceník </v-card-title>
          <v-skeleton-loader :loading="loading" :types="skeleton" type="article, actions">
            <v-card-text class="pa-7">
              <v-row>
                <v-col cols="12" sm="4" class="py-0">
                  <VDatePickerWithValidation
                    v-model="validSince"
                    date-format="dd.MM.yyyy"
                    rules="required"
                    outlined
                    dense
                    label="Platnost od"
                  />
                </v-col>
              </v-row>
              <v-row v-for="distributor in distributorPrices.distributors" :key="distributor.id">
                <v-col cols="12" class="mb-6">
                  <div class="mb-10 pa-2" style="background-color: black">
                    <h2 class="white--text">{{ distributor.name.toUpperCase() }}</h2>
                  </div>
                  <v-row
                    v-for="rate in distributor.rates"
                    :key="rate.id"
                    align="center"
                    justify="center"
                  >
                    <v-col cols="12" sm="3" class="py-0 px-5 pb-3 pa-3">
                      <H3>{{ rate.name }}</H3>
                    </v-col>
                    <v-col cols="12" sm="3" class="py-0 px-5 pb-3 pa-3">
                      <VTextFieldWithValidation
                        v-model="rate.priceHighTariff"
                        rules="required"
                        outlined
                        type="number"
                        dense
                        label="Cena VT"
                        :hide-messages="true"
                      />
                    </v-col>
                    <v-col cols="12" sm="3" class="py-0 px-5 pb-3 pa-3">
                      <VTextFieldWithValidation
                        v-if="!rate.single"
                        v-model="rate.priceLowTariff"
                        rules="required"
                        outlined
                        type="number"
                        dense
                        label="Cena NT"
                        :hide-messages="true"
                      />
                    </v-col>
                    <v-col cols="12" sm="3" class="py-0 px-5 pb-3 pa-3">
                      <VTextFieldWithValidation
                        v-model="rate.priceFixedSalary"
                        rules="required"
                        outlined
                        type="number"
                        dense
                        label="Cena SP"
                        :hide-messages="true"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="pl-7 pr-7 pb-7">
              <v-spacer></v-spacer>
              <v-btn
                type="submit"
                height="40px"
                min-width="130px"
                color="primary"
                depressed
                :loading="saving"
              >
                Uložit
              </v-btn>
            </v-card-actions>
          </v-skeleton-loader>
        </v-card>
      </form>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import VDatePickerWithValidation from '../validators/VDatePickerWithValidation'
import formatDate from '@/utils/formatDate'

export default {
  name: 'SupplierElectricityProductPricesAddDialog',
  components: { VDatePickerWithValidation },
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@2',
      },
      distributors: [],
      rates: [],
      validSince: null,
      distributorPrices: {
        validSince: null,
        distributors: [],
      },
      distributorLoading: false,
      ratesLoading: false,
      saving: false,
      dialog: false,
    }
  },
  computed: {
    loading() {
      return this.distributorLoading || this.ratesLoading
    },
  },
  watch: {
    validSince: {
      handler() {
        this.distributorPrices.validSince = formatDate(this.validSince)
      },
    },
  },
  created() {
    const model = this
    this.$eventBus.$on('supplierElectricityProductPricesAddDialog', function (dialog) {
      model.validSince = null
      model.distributorPrices.validSince = null
      model.distributorPrices.distributors = []
      model.createDistributorRateForm()
      model.dialog = dialog
    })
    this.loadDistributors()
  },
  methods: {
    ...mapActions({
      searchDistributor: 'electricity/searchDistributor',
      getRates: 'electricity/getRates',
      createSupplierProductPrice: 'supplier/createSupplierProductPrice',
    }),
    loadDistributors() {
      this.distributorLoading = true
      this.searchDistributor()
        .then((response) => {
          this.distributors = response.data.items
          this.loadRates()
        })
        .finally(() => {
          this.distributorLoading = false
        })
    },
    loadRates() {
      this.ratesLoading = true
      this.getRates()
        .then((response) => {
          this.rates = response.data
          this.createDistributorRateForm()
        })
        .finally(() => {
          this.ratesLoading = false
        })
    },
    async createDistributorRateForm() {
      this.distributors.forEach((d) => {
        let distributor = {
          id: d.id,
          name: d.name,
          rates: [],
        }
        this.rates.map((rate) => {
          distributor.rates.push({
            id: rate.id,
            name: rate.name,
            single: rate.single,
            priceHighTariff: '0',
            priceLowTariff: '0',
            priceFixedSalary: '0',
          })
        })
        this.distributorPrices.distributors.push(distributor)
      })
    },
    submit() {
      this.saving = true
      this.createSupplierProductPrice({
        supplierId: this.$route.params.supplierId,
        productId: this.$route.params.productId,
        type: this.$route.params.type,
        prices: this.distributorPrices,
      }).finally(() => {
        this.saving = false
        this.validSince = null
        this.distributorPrices.validSince = null
        this.distributorPrices.distributors = []
        this.createDistributorRateForm()
        this.$emit('priceCreated')
        this.close()
      })
    },
    close() {
      this.dialog = false
    },
  },
}
</script>
